import { render } from "./_tool-modal.vue?vue&type=template&id=4a819158"
import script from "./_tool-modal.vue?vue&type=script&lang=js"
export * from "./_tool-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__